import script from "./goodInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./goodInfo.vue?vue&type=script&setup=true&lang=js"

import "./goodInfo.vue?vue&type=style&index=0&id=33a50774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a50774"]])

export default __exports__